module.exports = __webpack_public_path__ + "img/diente11.5509da39.png";